// Static definitions for the rules rendered inside the "Manage Access Rules"
// side panel. Keys map back to `state.access_enabled` / `state.access_rules`
// in `configuration.js` so the panel stays declarative.
export const ACCESS_RULE_DEFS = [
    {
        key: 'negativeBalance',
        daysKey: 'negativeBalanceDays',
        title: 'Negative Balance',
        prefix: 'Negative >',
        suffix: 'days'
    },
    {
        key: 'overdraftNsf',
        daysKey: 'overdraftNsfDays',
        title: 'Overdraft & NSF Instances',
        prefix: 'Negative >',
        suffix: 'days'
    },
    {
        key: 'loansOverdue',
        daysKey: 'loansOverdueDays',
        title: 'Loans Overdue',
        prefix: 'No loan over',
        suffix: 'days late'
    }
];
